import React from "react";
import Layout from "../../components/organisms/Layout";
import Details from "../../components/pages/product-detail/Details";
import Insurance from "../../components/molecules/InsuranceList";
import IMG from "../../assets/images/product-detail/company/ACCIDENTES.png";
import { DetailWithImage } from "../../components/pages/quote/DetailWithImage";
import Technology from "../../components/pages/product-detail/Technology";

const Accident = ({}) => {
	return (
		<Layout landingPage='company'>
			<Details
				type='company_accident'
				title={"Seguro de Accidentes Personales"}
			/>
			<DetailWithImage
				title={
					<h1>
						Tranquilidad <span className='text-primary'>en el trabajo</span>
					</h1>
				}
				content='Protege a tu personal contra riesgo graves de accidentes en Gastos Médicos ó muerte a tus colaboradores.'
				image={IMG}
			/>
			<Technology />
			<Insurance
				type='company'
				current='accident'
				title='Una amplia gama de seguros'
			/>
		</Layout>
	);
};
export default Accident;
